module.exports = __webpack_public_path__ + "static/media/intro.e7efe382.mp3";